import {
  gql,
  OperationVariables,
  QueryHookOptions,
  useLazyQuery,
} from '@apollo/client';
import { IGetAlertMetadata } from './types';

export const GET_ALERT_METADATA_NON_SURICATA_ALERT_ATTACK = gql`
  query getAlertMetadataNonSuricataAlertAttack(
    $items: [GetAlertMetadataInput]!
  ) {
    getAlertMetadata(items: $items) {
      metadata {
        chatbot_chats {
          non_suri_alert_attack
        }
      }
    }
  }
`;

export const useGetAlertMetadataNonSuricataAlertAttack = (
  options: QueryHookOptions<IGetAlertMetadata, OperationVariables>,
) =>
  useLazyQuery<IGetAlertMetadata>(
    GET_ALERT_METADATA_NON_SURICATA_ALERT_ATTACK,
    options,
  );
